(() => {
  const rootSelector = '.template-product :is([class^="rapi-bundle-content-"], [class*=" rapi-bundle-content-"])';
  const radioSelector = '.rapi-bundles__bar > input[type="radio"][readonly]';
  let spaceRadio = null;

  function isAvailable(element) {
    if (!element?.isConnected || element.closest('[hidden], [inert], [aria-hidden="true"], [aria-disabled="true"], .rapi-bundle-offer-sold-out')) {
      return false;
    }
    if (element.matches(':disabled, [disabled]')) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function getTier(radio) {
    if (!radio?.matches?.(radioSelector) || !isAvailable(radio)) return null;
    const root = radio.closest(rootSelector);
    const bar = radio.parentElement;
    const label = radio.nextElementSibling;
    if (!root || !radio.name || !radio.id || !label?.matches('label.rapi-bundles__bar-container') || label.htmlFor !== radio.id) {
      return null;
    }

    // Rapi's label handler only accepts clicks originating in the outer content.
    // Clicking the input or the label itself does not select the controlled tier.
    const target = label.querySelector('.rapi-content-outer-wrapper .rapi-bundles__bar-main');
    if (!target || target.closest('.rapi-content-inner-wrapper') || target.closest('.rapi-bundles__bar') !== bar || !isAvailable(target)) {
      return null;
    }
    return { radio, root, target };
  }

  function selectTier(tier) {
    tier.radio.focus({ preventScroll: true });
    // The app remains responsible for checked state, offer contents, and prices.
    if (!tier.radio.checked) tier.target.click();
  }

  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    const tier = getTier(event.target);
    if (!tier) return;

    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (event.repeat) return;
      if (event.key === ' ') spaceRadio = tier.radio;
      else selectTier(tier);
      return;
    }

    const direction = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
    if (!direction) return;
    const tiers = Array.from(tier.root.querySelectorAll(radioSelector))
      .filter((radio) => radio.name === tier.radio.name && radio.form === tier.radio.form)
      .map(getTier)
      .filter((candidate) => candidate && candidate.root === tier.root);
    const index = tiers.findIndex((candidate) => candidate.radio === tier.radio);
    if (index < 0 || !tiers.length) return;
    event.preventDefault();
    spaceRadio = null;
    if (!event.repeat) selectTier(tiers[(index + direction + tiers.length) % tiers.length]);
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== ' ' || !spaceRadio) return;
    const radio = spaceRadio;
    spaceRadio = null;
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    event.preventDefault();
    const tier = getTier(radio);
    if (tier && document.activeElement === radio) selectTier(tier);
  });

  document.addEventListener('focusout', (event) => {
    if (event.target === spaceRadio) spaceRadio = null;
  });
  window.addEventListener('blur', () => { spaceRadio = null; });
  window.addEventListener('pageshow', () => { spaceRadio = null; });
})();
